import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, memo, useMemo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductBadge } from '@spa/components/product-info/ProductInfoProductTypes';
import classNames from 'clsx';
import { productBadgesLimit } from '@spa/lib/const';
import styles from './product-badges.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly badges: ReadonlyArray<ProductBadge> | null;
  readonly isProductOnSale: boolean;
  readonly maxVisibleBadges?: number;
  readonly productIsUnavailable?: boolean;
  readonly isOnProductTile?: boolean;
  readonly isPreOrderActive?: boolean;
  readonly isPreOrderProduct?: boolean;
}
const BADGE_PRIORITY: Record<ProductBadge, number> = {
  [ProductBadge.PREORDER]: 1,
  [ProductBadge.SALE]: 2,
  [ProductBadge.OWN_BRAND]: 3,
  [ProductBadge.GIFT_WITH_PURCHASE]: 4,
  [ProductBadge.MULTIPACK]: 5,
  [ProductBadge.EXCLUSIVE_ONLINE]: 6,
  [ProductBadge.NEW]: 7,
  [ProductBadge.EXCLUSIVE]: 8
};
function ProductBadgesComponent(t0) {
  const $ = _c(15);
  const {
    badges,
    isProductOnSale,
    maxVisibleBadges,
    productIsUnavailable,
    isOnProductTile,
    isPreOrderActive,
    isPreOrderProduct
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("product-badges");
  let t1;
  if ($[0] !== badges || $[1] !== isPreOrderActive || $[2] !== isProductOnSale || $[3] !== maxVisibleBadges) {
    const productBadges = badges ?? [];
    const combinedBadges = [...(isProductOnSale ? [ProductBadge.SALE] : []), ...(isPreOrderActive ? [ProductBadge.PREORDER] : []), ...productBadges];
    t1 = [...new Set(combinedBadges)].sort(_temp).slice(0, maxVisibleBadges ?? productBadgesLimit);
    $[0] = badges;
    $[1] = isPreOrderActive;
    $[2] = isProductOnSale;
    $[3] = maxVisibleBadges;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const badgesToRender = t1;
  let t2;
  if ($[5] !== isOnProductTile) {
    t2 = classNames({
      [styles["product-badges"]]: true,
      [styles["product-badges--product-tile"]]: isOnProductTile
    });
    $[5] = isOnProductTile;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const productBadgesClass = t2;
  let t3;
  if ($[7] !== badgesToRender || $[8] !== formatMessage || $[9] !== isPreOrderProduct || $[10] !== productIsUnavailable) {
    t3 = productIsUnavailable && !isPreOrderProduct ? <div className={classNames(styles["product-badges__unavailable"], "text-s-immutable body-bold")}>{formatMessage("unavailableLabel")}</div> : badgesToRender.map(badge => <div key={badge} className={styles["product-badges__badge"]}><ImageComponent className={styles["product-badges__icon"]} src={`/assets/icons/badge-${badge}.svg`} alt={formatMessage(`alternativeTextForIcon.${badge}`)} width={63} height={38} /><span className={styles["product-badges__text"]}>{formatMessage(`text.${badge}`)}</span></div>);
    $[7] = badgesToRender;
    $[8] = formatMessage;
    $[9] = isPreOrderProduct;
    $[10] = productIsUnavailable;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== productBadgesClass || $[13] !== t3) {
    t4 = <div className={productBadgesClass}>{t3}</div>;
    $[12] = productBadgesClass;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
function _temp(a, b) {
  return BADGE_PRIORITY[a] - BADGE_PRIORITY[b];
}
export default memo(ProductBadgesComponent);